module.exports = __webpack_public_path__ + "img/icon-draft.91da6053.svg";